// AdminLayout.jsx
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';
import HeaderBar from '../components/layout/HeaderBar';
import Sidebar from '../components/layout/Sidebar';
import ThemeSelector from '../components/ThemeSelector';

const AdminLayout = () => {
  const { theme } = useTheme();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // Sidebar collapsed state persisted in localStorage
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('patrolVisitSidebarCollapsed') === 'true';
  });

  useEffect(() => {
    localStorage.setItem(
      'patrolVisitSidebarCollapsed',
      String(isSidebarCollapsed)
    );
  }, [isSidebarCollapsed]);

  const [showThemeSelector, setShowThemeSelector] = useState(false);

  return (
    <div className={`min-h-screen bg-gradient-to-br ${theme.bgGradient}`}>
      {/* Theme Picker Modal */}
      <ThemeSelector
        isOpen={showThemeSelector}
        onClose={() => setShowThemeSelector(false)}
      />

      {/* Header */}
      <HeaderBar
        onToggleMobileSidebar={() =>
          setIsMobileSidebarOpen((open) => !open)
        }
        onOpenThemeSelector={() => setShowThemeSelector(true)}
        onToggleSidebarCollapse={() =>
          setIsSidebarCollapsed((v) => !v)
        }
        isSidebarCollapsed={isSidebarCollapsed}
      />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar
          isMobileOpen={isMobileSidebarOpen}
          isCollapsed={isSidebarCollapsed}
        />

        {/* MAIN CONTENT AREA */}
        <div className="flex-1 p-6">
          {/* OUTLET IS CRITICAL → renders /dashboard, /guards, etc. */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;